import { analyzePrompt, type CreatePromptMessageRequest } from '@/entities/discovery';
import { useAbortableMutation } from '@/shared/hooks/use-abortable-mutation';
import { v4 as uuidv4 } from 'uuid';

import { useDiscoveryMessagesActions } from '../stores/discovery-message-store';
import { searchCreatorPendingAtom } from '../stores/mutation-atom';
import { usePendingDiscoveryActionActions } from '../stores/pending-discovery-action-store';

type AnalyzeDiscoveryPromptMutationRequest = {
  discoverySessionId: string;
  request: CreatePromptMessageRequest;
};

export function useAnalyzeDiscoveryPrompt() {
  const { appendMessages } = useDiscoveryMessagesActions();
  const { addPendingAction, removePendingAction } = usePendingDiscoveryActionActions();

  return useAbortableMutation({
    mutationFn: (request: AnalyzeDiscoveryPromptMutationRequest, signal) =>
      analyzePrompt(request.discoverySessionId, request.request, signal),
    onMutate: ({ discoverySessionId, request }) => {
      const pendingActionId = uuidv4();
      addPendingAction({
        id: pendingActionId,
        sessionId: discoverySessionId,
        type: 'prompt',
        message: request.message,
      });

      return { pendingActionId };
    },
    onSuccess: (response) => {
      appendMessages([response.assistant_message, response.user_message]);
    },
    onSettled: (_data, _error, _variables, context) => {
      if (context) removePendingAction(context.pendingActionId);
    },
    pendingAtom: searchCreatorPendingAtom,
    requestKey: 'discovery:analyze-discovery',
  });
}
